import { Injectable, inject } from '@angular/core';

import { Firestore, getDoc, setDoc, deleteDoc, doc, onSnapshot } from '@angular/fire/firestore';

// Needed to set conditions when getting collections 
import { collection, query, where, orderBy, limit, startAfter, WhereFilterOp, DocumentSnapshot, QueryDocumentSnapshot, getDocs } from '@angular/fire/firestore';
export interface Condition {
  key: 'where' | 'orderBy' | 'limit' | 'startAfter';
  value: WhereCondition | OrderByCondition | number | DocumentSnapshot;
}
export type WhereCondition = [string, WhereFilterOp, any];
export type OrderByCondition = [string, 'asc' | 'desc'];

// Needed to get server timpestamp
import { serverTimestamp } from 'firebase/firestore';

// Environment varialbes
import { environment } from '../../../environments/environment';

// http service
import { HttpService } from '../http/http.service';


@Injectable({
  providedIn: 'root'
})
export class FirestoreService {


  private currentOnChangeListenner_HttpRequests:any = null

  private firestore = inject(Firestore)

  constructor(public httpService:HttpService) { }


  // Add document to DB
  public addDocument(collection: string, documentId: string, data: any){
    const docRef = doc(this.firestore, collection, documentId);
    return setDoc(docRef, data);
  }

  // Get document from DB
  public getDocument(collection: string, documentId: string) {
    const docRef = doc(this.firestore, collection, documentId);
    return getDoc(docRef);
  }

  // Delete document
  public deleteDocument(collection: string, documentId: string) {
    const docRef = doc(this.firestore, collection, documentId);
    return deleteDoc(docRef);
  }


  // Get collection from DB
  //  Possible filters
  //    {key:'where', value:['parameter', 'condition', 'comparison value']}
  //    {key:'orderBy', value:'parameter'}
  //    {key:'limit', value:number}
  //    {key:'startAfter', value:lasDocument}
  public getCollection(collectionPath: string, conditionsList: Condition[] = []) {
    let q = query(collection(this.firestore, collectionPath));

    conditionsList.forEach(condition => {
      switch (condition.key) {
        case 'where':
          q = query(q, where(...condition.value as WhereCondition));
          break;
        case 'orderBy':
          q = query(q, orderBy(...condition.value as OrderByCondition));
          break;
        case 'limit':
          q = query(q, limit(condition.value as number));
          break;
        case 'startAfter':
          q = query(q, startAfter(condition.value as QueryDocumentSnapshot));
          break;
      }
    });
    return getDocs(q);
  }




  // Get firebase hash (document ID)
  public getFirebaseHash(){
    const newDocRef = doc(collection(this.firestore, 'server'));
    return newDocRef.id;
  }

  // Get firebase timestamp
  public getFirebaseTimestamp(){
    return serverTimestamp();
  }


  // Get collection from DB
  async getDocumentListFromCollection(collection: string, conditionsList:any=[]){
    // Get the collection snapshot
    let collectionSnapshot = await this.getCollection(collection, conditionsList)
    // Store the documents to a single list
    let documentList:any = []    
    for(let documentSnapshot of collectionSnapshot.docs){
      let docId = documentSnapshot.id
      let docData = documentSnapshot.data()
      documentList.push({id:docId,data:docData})
    }
    // Return the result dict
    return documentList    
  }













}
